export function authHandler(config: any) {
  const testData = window.sessionStorage.getItem('testData')
  const token = window.sessionStorage.getItem('access_token');
  config.headers.Authorization = `Bearer ${token}`;

  if (testData === 'true') {
    config.headers['X-Test'] = true
  }

  return config;
}
